import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { BrandButton } from "@/components/PageHeader";
import { api, errMsg, fmtDate } from "@/lib/api";

const History = ({ items }) => items.length > 0 && (
  <div className="rounded-md bg-[#F8F9FA] border p-3 text-xs space-y-1.5 max-h-40 overflow-auto" data-testid="cert-name-history">
    <div className="font-bold uppercase tracking-wider text-[10px] text-gray-500">Earlier corrections</div>
    {items.map((h, i) => <div key={i}><span className="text-gray-500">{fmtDate(h.at)} · {h.by || "staff"}:</span> {h.old || "—"} → <span className="font-semibold">{h.new}</span> <span className="text-gray-500">({h.reason})</span></div>)}
  </div>
);

export const CertNameDialog = ({ eventId, row, onClose, onSaved }) => {
  const [name, setName] = useState(row.cert_name_missing ? "" : row.certificate_name);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [hist, setHist] = useState([]);
  useEffect(() => {
    api.get(`/cert-dispatch/${eventId}/rows/${row.id}/certificate-name/history`).then((r) => setHist(r.data)).catch(() => setHist([]));
  }, [eventId, row.id]);
  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/cert-dispatch/${eventId}/rows/${row.id}/certificate-name`, { name, reason });
      toast.success(row.cert?.sent_at ? "Certificate name saved. Resend to email the corrected certificate." : "Certificate name saved");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  const ok = name.trim().length >= 2 && reason.trim().length >= 3;
  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="cert-name-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Correct certificate name</DialogTitle>
          <DialogDescription>{row.name} · {row.ticket_no}. This also updates the member's account, so future certificates use it.</DialogDescription>
        </DialogHeader>
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name as it should appear on the certificate" className="h-11" data-testid="cert-name-input" />
        <Textarea rows={2} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason for the correction" data-testid="cert-name-reason" />
        <History items={hist} />
        <div className="flex justify-end gap-2">
          <BrandButton variant="outline" onClick={onClose} data-testid="cert-name-cancel">Cancel</BrandButton>
          <BrandButton onClick={save} disabled={!ok || busy} data-testid="cert-name-save">{busy ? "Saving…" : "Save name"}</BrandButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
